import { NewProduct } from 'src/app/models/response/galleryDashboard.models';
import { AuthConfig, AuthService } from 'src/app/Services/auth.service';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DashboardService } from 'src/app/Services/dashboard.service';
import { ArtistDashboard, RecentSale } from 'src/app/models/response/artistdashboard.models';
import { OnBoardingService } from 'src/app/Services/shared/onboarding.service';
import { ImageUtils } from 'src/app/shared/utils/image-utils';

@Component({
    selector: 'artist-dashboard',
    templateUrl: './artist-dashboard.component.html',
    styleUrls: ['./artist-dashboard.component.css'],
    providers: [DashboardService],
    standalone: false
})
export class ArtistDashboardComponent implements OnInit {
    public dashboardData: ArtistDashboard = {
        IncomingArtistConnectionRequest: []
    };
    public artistId!: string;
    public dashboardDataLoaded: boolean = false;
    public selectedTabIndex: number = 0;
    public isAuthenticated!: boolean;
    public isArtist: boolean = false;
    public showDashboard: boolean = true;
    public authConfig: AuthConfig = {};


    public ngOnInit(): void {
        this.getArtistDashboard()
        this.artistId = this.authService.getUserId();
        this.isAuthenticated = this.authService.isAuthenticated();
        if (this.isAuthenticated) {
            this.authConfig = this.authService.getAuthConfig();
            this.isArtist = this.authConfig.IsGallery || false;
            var currentUser = this.authService.getCurrentUser();
            this.onBoardingService.getUpdatedLocalStorageValue.subscribe((tourVisible: boolean) => {
                this.showDashboard = !tourVisible;
                // console.log('TourVisible: ' + tourVisible);
            });
        }

    }

    constructor(private ngxSpinner: NgxSpinnerService,
        private router: Router, private authService: AuthService,
        private dashboardService: DashboardService,
        private onBoardingService: OnBoardingService) { }

    public getArtistDashboard() {
        this.ngxSpinner.show();
        this.dashboardService.getArtistDashboard().subscribe((data: ArtistDashboard) => {
            data.BestPerformingSeriesData?.forEach((item) => {
                // Set the color class based on the percentage
                var colorClass = this.getColorBasedOnPercentage(item.PercentageOfTotal);
                item.ColorClassBasedOnPercentage = 'bg-' + colorClass;
                item.TextBasedOnPercentage = `<span class="text-${colorClass}">${item.PercentageOfTotal}%</span>`;
            });
            this.dashboardData = data;
            if (data.RecentSales) {
                this.dashboardData.RecentSales = data.RecentSales.map((item) => {
                    item.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(item.ProductImageUrl || 'assets/images/No-Image.png');
                    return item
                });
            }
            if(data.NewProductsAdded){
                this.dashboardData.NewProductsAdded = data.NewProductsAdded.map((item) => {
                    item.ResizedImageUrl = ImageUtils.getResizedCloudinaryUrl(item.ProductImageUrl || 'assets/images/No-Image.png');
                    return item
                });
            }
            this.ngxSpinner.hide();
            this.dashboardDataLoaded = true;
        }, error => { console.error(error); this.ngxSpinner.hide(); });
    }

    private getColorBasedOnPercentage(percentage: number): string {
        if (percentage >= 75) {
            return 'success';
        } else if (percentage >= 50) {
            return 'info';
        } else if (percentage >= 25) {
            return 'warning';
        }
        return 'danger';
    }

    public goToProductDetails(product: any) {
        this.router.navigate(['/', this.artistId, 'artworks', product.ProductId]);
    }
    public goToProductRequestPage() {
        this.router.navigate(['/artists', 'product-requests',]);
    }

    public onViewConsignmentsClicked(data: any) {
        if (data && data.GalleryId) {
            this.router.navigate(['/artists', 'gallery', data.GalleryId, 'gallery-products']);
        } else {
            console.error('Invalid data object:', data);
        }
    }
    public ChatwithGallery(data: any) {
        if (data && data.Id) {
            this.router.navigate(['/inbox', data.Id,]);
        } else {
            console.error('Invalid data object:', data);
        }
    }
    
    getFirstSentence(message: string, wordCount: number = 10 ): string {
        if (!message) return '';
        const words = message.split(' ');
        if (words.length <= wordCount) {
            return message;
        }
        return words.slice(0, wordCount).join(' ') + '...';
    }

    public onTabChange(event: any) {
        if (event.index) {
            this.selectedTabIndex = event.index;
        } else {
            console.log('Event is undefined or index is not present');
        }
    }
   
    
}

